export default [

  {
    path: '/activations',
    name: 'activation list',
    component: () => import('@/views/Activation/SimActivationOrder'),
    meta: {
      pageTitle: 'Activations',
      breadcrumb: [
        {
          text: 'Activations',
          active: true,
        },
      ],
    },
  },
    {
        path: '/activations/create',
        name: 'activation create',
        component: () => import('@/views/Activation/SimActivationBySteps'),
        meta: {
            action:'activation create',
            pageTitle: 'Activate',
            breadcrumb: [
                {
                    text: 'New Activation',
                    active: true,
                },
            ],
        },
    },

  {
    path: '/activations/order/:id',
    name: 'activation list details',
    component: () => import('@/views/Activation/SimActivationOrderSingle'),
    meta: {
      action:'activation list',
      pageTitle: 'Activations',
      breadcrumb: [
        {
          text: 'Activations',
          active: true,
        },
      ],
    },
  },

  {
    path: '/activation/customer-lookup',
    name: 'customer lookup',
    component: () => import('@/views/Activation/CustomerLookup'),
    meta: {
      pageTitle: 'Customer Lookup',
      breadcrumb: [
        {
          text: 'Customer Lookup',
          active: true,
        },
      ],
    },
  },

  {
    path: '/activation/customer-lookup/:id',
    name: 'customer lookup details',
    component: () => import('@/views/Activation/CustomerLookupDetail'),
    meta: {
      action:'customer lookup',
      pageTitle: 'Customer Details',
      breadcrumb: [
        {
          text: 'Customer Details',
          active: true,
        },
      ],
    },
  },

    {
        path: '/activation/customer/ultimate-mobile/:id',
        name: 'customer lookup details',
        component: () => import('@/views/Activation/CustomerUltimateDetail'),
        meta: {
            action:'customer lookup',
            pageTitle: 'Customer Details',
            breadcrumb: [
                {
                    text: 'Customer Details',
                    active: true,
                },
            ],
        },
    },

    {
    path: '/activation/activate/:code',
    name: 'activation create',
    component: () => import('@/views/Activation/SimActivation'),
    meta: {
      pageTitle: 'Activation',
      breadcrumb: [
        {
          text: 'Activation',
          active: true,
        },
      ],
    },
  },

  {
    path: '/activation/carrier',
    name: 'carrier admin list',
    component: () => import('@/views/Activation/Carrier/CarrierAdminList'),
    meta: {
      pageTitle: 'Carriers',
      breadcrumb: [
        {
          text: 'Carriers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/activation/carrier/:id',
    name: 'carrier admin update',
    component: () => import('@/views/Activation/Carrier/CarrierAdminUpsert'),
    meta: {
      pageTitle: 'Carrier Update',
      breadcrumb: [
        {
          text: 'Carrier Update',
          active: true,
        },
      ],
    },
  },

  {
    path: '/activation/swap/number',
    name: 'activation mdn swap',
    component: () => import('@/views/Activation/Swaps/Mdn/MakeSwap'),
    meta: {
      pageTitle: 'Number Swap',
      breadcrumb: [
        {
          text: 'Number Swap',
          active: true,
        },
      ],
    },
  },

  {
    path: '/activation/swap/device',
    name: 'activation esn swap',
    component: () => import('@/views/Activation/Swaps/Device/MakeSwap'),
    meta: {
      pageTitle: 'Device Swap',
      breadcrumb: [
        {
          text: 'Device Swap',
          active: true,
        },
      ],
    },
  },

  {
    path: '/activation/swap/sim',
    name: 'activation sim swap',
    component: () => import('@/views/Activation/Swaps/Sim/MakeSwap'),
    meta: {
      pageTitle: 'Sim Swap',
      breadcrumb: [
        {
          text: 'Sim Swap',
          active: true,
        },
      ],
    },
  },

  {
    path: '/activation/plan',
    name: 'activation plan list',
    component: () => import('@/views/Activation/Plan/List'),
    meta: {
      pageTitle: 'Activation Plan',
      breadcrumb: [
        {
          text: 'Activation Plan',
          active: true,
        },
      ],
    },
  },

  {
    path: '/activation/plan/:id/update',
    name: 'activation plan update',
    component: () => import('@/views/Activation/Plan/Upsert'),
    meta: {
      pageTitle: 'Activation Plan',
      breadcrumb: [
        {
          text: 'Activation Plan',
          active: true,
        },
      ],
    },
  },

  {
    path: '/activation/plan/create',
    name: 'activation plan create',
    component: () => import('@/views/Activation/Plan/Upsert'),
    meta: {
      pageTitle: 'Activation Plan',
      breadcrumb: [
        {
          text: 'Activation Plan',
          active: true,
        },
      ],
    },
  },

  {
    path: '/mvno',
    name: 'mvno list',
    component: () => import('@/views/Carrier/CarrierList.vue'),
    meta: {
      action:'carrier admin list',
      pageTitle: 'MVNO Carriers',
      breadcrumb: [
        {
          text: 'MVNO Carriers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/mvno/update/:id',
    name: 'mvno update',
    component: () => import('@/views/Carrier/CarrierUpdate.vue'),
    meta: {
      action:'carrier admin list',
      pageTitle: 'Carrier Update',
      breadcrumb: [
        {
          text: 'Carrier Update',
          active: true,
        },
      ],
    },
  },
  {
    path: '/mvno/update/plan/:id',
    name: 'mvno plan update',
    component: () => import('@/views/Carrier/PlanUpdate.vue'),
    meta: {
      action:'carrier admin update',
      pageTitle: 'Carrier Plan Update',
      breadcrumb: [
        {
          text: 'Carrier Plan Update',
          active: true,
        },
      ],
    },
  },
]
